import { pathWithPosReturnHash, savePosReturnHash } from '~/lib/loginReturnHash'
import { clearStaffReasonFlow } from '~/lib/sessionRecovery'

// Shared post-sign-in tail used by every better-auth login method (social, email
// OTP, static-token direct sign-in link, staff-access bridge). Syncs the resulting
// better-auth session into the PHP backend session, joins the socket channel(s),
// loads user data, and reloads the app - or throws STAFF_REASON_REQUIRED so the
// caller can collect a staff access reason and retry.
export interface FinishLoginTailParams {
  store: any
  socket: any
  linkedStores?: Array<{ shopid: string }>
  shopId: string
  clientid?: string | null
  session?: { value?: { data?: { session?: { token?: string } } } }
  staffReason?: string
  staffReasonDetail?: string
  // Where to land once finished, if not the current page - needed by callers
  // that live outside the main app page (e.g. the direct sign-in link page),
  // which has no reason to stick around once signed in. Defaults to just
  // reloading the current page in place, which is correct for callers that
  // are the main app page itself (e.g. Login.vue, rendered inline in it).
  redirectTo?: string
}

export async function finishLoginTail ({
  store,
  socket,
  linkedStores,
  shopId,
  clientid,
  session,
  staffReason,
  staffReasonDetail,
  redirectTo
}: FinishLoginTailParams) {
  const token = session?.value?.data?.session?.token
  await store.dispatch('syncBackendAuth', {
    shopId,
    clientid,
    authToken: token ? 'betterauth:' + token : undefined,
    staffReason,
    staffReasonDetail
  })
  if (!store.state.user) {
    throw new Error('You do not have access to this shop')
  }
  socket.emit('channel', { action: 'join', shopId })
  if (linkedStores && linkedStores.length) {
    for (let i = 0; i < linkedStores.length; i++) {
      socket.emit('channel', {
        action: 'join',
        shopId: linkedStores[i].shopid
      })
    }
  }
  await store.dispatch('userdata')
  store.dispatch('setSessionExpired', false)
  clearStaffReasonFlow()
  savePosReturnHash(shopId)
  if (redirectTo) {
    window.location.href = pathWithPosReturnHash(redirectTo, shopId)
  } else {
    // reloadNuxtApp defaults to pathname only, which drops the hash (and any
    // leftover query). Carry the POS UI hash through so open editors survive.
    const path = pathWithPosReturnHash(
      window.location.pathname + window.location.search,
      shopId
    )
    reloadNuxtApp({ persistState: true, path })
  }
}
